<div class="modal-header" mat-dialog-title>
  <div class="modal-header-titles">
    <h2 class="modal-title">Ordens relacionadas geradas</h2>
  </div>
  <div class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn" (click)="dialogRef.close()">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="modal-content">
  @if (gerouAlguma) {
  <p class="subtitulo">
    Geradas a partir de OP {{ data.numeroOrigem }}, com base nos itens de
    matéria-prima fabricados na composição.
  </p>

  <div class="lista-ordens">
    @for (ordem of data.ordensGeradas; track ordem.idOrdemProducao) {
    <div class="linha-ordem" (click)="abrirOrdem(ordem.idOrdemProducao)">
      <mat-icon class="material-symbols-outlined">account_tree</mat-icon>
      <div class="ordem-info">
        <div class="ordem-titulo">OP {{ ordem.numero }} · {{ ordem.nomeProduto }}</div>
        <div class="ordem-detalhe">
          {{ ordem.codigoSku }} · qtd. {{ ordem.quantidade }} · gerada a partir da OP
          {{ ordem.numeroOrdemProducaoPai }}
        </div>
      </div>
    </div>
    }
  </div>
  } @else if (todasJaExistiam) {
  <p class="subtitulo">
    Todos os itens de matéria-prima fabricados da composição de OP {{ data.numeroOrigem }} já
    possuem ordem de produção gerada anteriormente.
  </p>
  } @else {
  <p class="subtitulo">
    Nenhum item de matéria-prima fabricado foi encontrado na composição de OP
    {{ data.numeroOrigem }}.
  </p>
  }
</mat-dialog-content>

<mat-dialog-actions class="modal-footer">
  <button mat-flat-button class="btn-primary" (click)="dialogRef.close()">Entendi</button>
</mat-dialog-actions>